<template>
  <div class="select-wrap" @mouseleave="isSelectOpen = false">
    <h5>{{ title }}</h5>
    <div>
      <div class="select-title" @click="isSelectOpen = true">
        {{selectedItem.text}}
      </div>
      <ul v-if="isSelectOpen">
        <template v-for="(item, index) in itemList">
          <li v-bind:key="index" :data-value="item.value" @click="onSelectItem(item)">
            {{item.text}}
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'RadioItem',
  props: {
    title: {
      type: String,
      default: ''
    },
    errorText: {
      type: String,
      default: ''
    },
    baseText: {
      type: String,
      default: null
    },
    contList: {
      type: String,
      default: null
    },
    index: {
      type: Number,
      default: 0
    },
    modelValue: {
      default: '',
      required: false
    },
    itemList: []
  },
  components: {

  },
  watch: {
    modelValue () {
      this.defaultValueSetting()
    }
  },
  created () {
    this.defaultValueSetting()
  },
  destroyed () {
  },
  methods: {
    defaultValueSetting () {
      if (this.itemList.length > 0) {
        let selectedItem = ''
        for (let i = 0, iLen = this.itemList.length; i < iLen; i++) {
          const item = this.itemList[i]

          if (this.modelValue) {
            if (this.modelValue === item.value) {
              selectedItem = item
              break
            }
          } else {
            if (item.default) {
              selectedItem = item
              break
            }
          }
        }

        if (!selectedItem) {
          selectedItem = this.itemList[0]
        }

        this.selectedItem = selectedItem
      }
    },
    onSelectItem (item) {
      this.selectedItem = item
      this.isSelectOpen = false
      this.$emit('input', this.selectedItem, this.index)
    }
  },
  computed: {

  },
  data () {
    return {
      isSelectOpen: false,
      selectedItem: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.select-wrap {
  max-width: 230px;
  height: auto;
  margin-bottom: 40px;
  h5 {
    font-size: 13px;
    font-weight: 500;
    line-height: 1;
    color: #767676;
    margin: 0 0 5px 5px;
  }
  div {
    color: #2f2f2f;
    font-size: 14px;
    cursor: pointer;
    position: relative;
    .select-title {
      width: 100%;
      height: 40px;
      box-sizing: border-box;
      padding: 12px;
      border-radius: 6px;
      border: solid 1px #bbb;
      background: #fff;
      background: #fff url('../../assets/images/icon-select-arrow.svg') no-repeat center right 12px;
    }
    ul {
      width: 100%;
      border-radius: 6px;
      box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.25);
      overflow: hidden;
      position: absolute;
      top: 0;
      z-index: 10;
      li {
        height: 40px;
        line-height: 40px;
        box-sizing: border-box;
        padding-left: 15px;
        background: #fff;
        cursor: pointer;
        &:hover {
          background: #ebebeb;
        }
      }
    }
  }
}
</style>
